export default "__VITE_ASSET__Cw7LKbAr__"